module.exports = __webpack_public_path__ + "img/second-bg.088508d1.png";